import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { publicApi } from "@/lib/api";
import PublicHeader from "@/components/public/PublicHeader";
import PublicFooter from "@/components/public/PublicFooter";

export default function PublicLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    // Fire-and-forget visitor tracking (records first-time IPs for the dashboard).
    publicApi
      .post("/track", { path: pathname, referrer: document.referrer || "" })
      .catch(() => {});
  }, [pathname]);
  return (
    <div className="min-h-screen bg-white text-[#30383C]">
      <PublicHeader />
      <main>
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
